exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'dancing_script_otregular';\n  src: url(" + require("./dancingscript-regular-webfont.woff2") + ") format(\"woff2\"), url(" + require("./dancingscript-regular-webfont.woff") + ") format(\"woff\");\n  font-weight: normal;\n  font-style: normal; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/~/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/mac-jeremy/Projets/fairepart/~/postcss-loader?{"ident":"postcss"}!/Users/mac-jeremy/Projets/fairepart/~/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/Users/mac-jeremy/Projets/fairepart/src/assets/fonts/dancing/dancing.script.otregular.stylesheet.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/assets/fonts/dancing/dancing.script.otregular.stylesheet.scss
// module chunks = 1